import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MouseEventHandler } from "react";
import { useSelector } from "react-redux";

import { Case, Specimen } from "pwapi";

import { AuthState } from "shared/reducers/authReducer";
import { FeatureFlags } from "shared/reducers/sysReducer";
import { specimen_source } from "shared/utils/specimenUtils";

import { PathologyWatchButton } from "components/customInputs/buttons/Button";
import SplitParagraphs from "components/SplitParagraphs";
import { useAppSelector } from "store/hooks";

import { SpecimenDialogProps } from "./SpecimenDialogController";
import { isDiagnosable } from "./utils";

export const shouldShowSpecimenDialog = (specimen: Specimen) => {
  return !!(
    specimen &&
    (specimen?.clinical_history ||
      specimen_source(specimen) ||
      specimen?.gross_description)
  );
};

const SpecimenDialog = ({
  specimen,
  caseDetail,
  onEdit,
}: SpecimenDialogProps & { onEdit?: MouseEventHandler<HTMLButtonElement> }) => {
  const source = specimen && specimen_source(specimen);
  const currentUser = useSelector(
    ({ auth }: { auth: AuthState }) => auth?.user
  );

  const features: FeatureFlags = useAppSelector(({ sys }) => sys.features);

  return (
    <>
      <dl>
        <dt>Clinical History</dt>

        {specimen?.clinical_history ? (
          <dd>
            <SplitParagraphs paragraph={specimen?.clinical_history} />
          </dd>
        ) : (
          <dd className="Specimen__contentContainer__missing">
            <FontAwesomeIcon icon="exclamation-circle" color={"var(--red)"} />{" "}
            Missing Clinical History
          </dd>
        )}

        {source && (
          <>
            <dt>Source</dt>
            <dd>{source}</dd>
          </>
        )}

        <dt>Gross Description</dt>
        {specimen?.gross_description ? (
          <dd>{specimen?.gross_description}</dd>
        ) : (
          <dd className="Specimen__contentContainer__missing">
            <FontAwesomeIcon icon="exclamation-circle" color={"var(--red)"} />{" "}
            Missing Gross Description
          </dd>
        )}
      </dl>
      {caseDetail?.source === Case.source.PW &&
        isDiagnosable(caseDetail) &&
        features?.viewerSpecimenEdit &&
        currentUser &&
        (!specimen.lis_state ||
          specimen.lis_state === Specimen.lis_state.GROSSED) &&
        caseDetail?.active_assignment?.id === currentUser?.id && (
          <div className="Sidebar__controlContainer">
            <PathologyWatchButton
              onClick={onEdit}
              testId="specimen_edit_pencil"
              className="Sidebar__controlContainer--edit"
            >
              <FontAwesomeIcon icon="pencil-alt" />
            </PathologyWatchButton>
          </div>
        )}
    </>
  );
};

export default SpecimenDialog;
